import { LoadingIcon } from "Icons/Loading";

import { SerializedStyles, css } from "@emotion/react";

import { purple } from "constants/colors";

import { FieldLabel } from "./FieldLabel";
import { SpinningIcon } from "./SpinningIcon";

const style = {
  wrapper: css({
    height: 16,
    width: 16,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  input: css({ margin: 0, padding: 0, cursor: "pointer" }),
  container: css({
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
  }),
};

type Props = {
  onChange: (value: string) => void;
  groupName?: string;
  name: string;
  isChecked: boolean;
  isLoading?: boolean;
  showLabel?: boolean;
  customCss?: SerializedStyles;
};

export const Radio = ({
  isChecked,
  onChange,
  groupName,
  name,
  isLoading,
  showLabel,
  customCss,
}: Props) => {
  return (
    <div css={style.container} onClick={() => onChange(name)}>
      <div css={style.wrapper}>
        {isLoading ? (
          <SpinningIcon
            Icon={LoadingIcon}
            stroke={purple[600]}
            width={16}
            height={16}
          />
        ) : (
          <input
            css={style.input}
            type="radio"
            id={name}
            aria-label={name}
            name={groupName}
            checked={isChecked}
            onChange={(e) => {
              onChange(name);
              e.stopPropagation();
            }}
          />
        )}
      </div>
      {showLabel && (
        <FieldLabel
          label={name}
          customCss={{
            main: css({ marginBottom: 0 }),
            label: customCss,
          }}
        />
      )}
    </div>
  );
};
